var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyAdjustment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.655 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M16.351 4.694H1.321A1.313 1.313 0 0 0-.001 6.016v7.968a1.314 1.314 0 0 0 1.322 1.322h15.011a1.314 1.314 0 0 0 1.322-1.322V6.016a1.3 1.3 0 0 0-1.303-1.322m-12.726 9.5h-2.3a.22.22 0 0 1-.189-.207v-2.228h.208a2.293 2.293 0 0 1 2.284 2.285zm0-8.213a2.29 2.29 0 0 1-2.284 2.284h-.208V6.018a.19.19 0 0 1 .189-.189h2.3zm5.154 7.466a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.497zm7.762.521a.194.194 0 0 1-.189.207h-2.3v-.151a2.293 2.293 0 0 1 2.285-2.285h.208zm0-5.721h-.208a2.293 2.293 0 0 1-2.285-2.285v-.158h2.3a.22.22 0 0 1 .189.207zM1.133 3.368h15.408L11.093 0v2.016H1.134zM16.54 16.632H1.133L6.581 20v-2.016h9.959z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyAdjustment);
export default __webpack_public_path__ + "static/media/currencyAdjustment.01591cf0da19e2ecf6ac184b6848f57b.svg";
export { ForwardRef as ReactComponent };